import ExchangeIcon from "../images/ExchangeIcon.mjs";

/**
 * App icon for strategic associations page
 * @see {GlyphIcon}
 * @see {ExchangeIcon}
 */
const AppStrategicAssociationsIcon = class extends ExchangeIcon {}

export default AppStrategicAssociationsIcon;